<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ title_page }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CTabs variant="tabs" :active-tab="0">
                <!-- General -->
                <CTab :title="$t('Layouts')">
                    <CContainer class="mt-3" fluid>
                        <CRow>
                            <CCol>
                                <p>
                                    {{
                                        $t(
                                            "You can create templates from layouts"
                                        )
                                    }}.
                                </p>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                v-for="(layout, index) in layouts"
                                :key="index"
                                sm="2"
                            >
                                <CCard
                                    bodyWrapper
                                    class="card-layout"
                                    @click="createTemplate()"
                                >
                                    <CButton
                                        variant="outline-primary"
                                        class="btn__build-layout"
                                        @click="buildPreview(layout, $event)"
                                    >
                                        <CIcon
                                            size="lg"
                                            :content="$options.icons.eye"
                                        />
                                    </CButton>
                                    <CCardImg
                                        :src="layout.miniature"
                                        alt="layout"
                                        class="img-fluid"
                                    />
                                    <div class="card-description">
                                        <CCardTitle class="mt-2">
                                            {{ layout.name }}
                                        </CCardTitle>
                                        <CCardText>
                                            {{ layout.description }}
                                        </CCardText>
                                    </div>
                                </CCard>
                            </CCol>
                        </CRow>
                    </CContainer>
                </CTab>
                <!-- Modal privacy -->
                <CTab :title="$t('Themes')" :disabled="true"> </CTab>
            </CTabs>
        </CCardBody>
    </CCard>
</template>

<script>
import FilterDate from "~/components/FilterDate";
import layouts from "~/pages/app/templates/layouts.json";
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilCopy,
    cilMediaPlay,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import pageMixin from "~/mixins/page.js";
import { eye } from "~/assets/icons/js/eye";
export default {
    name: "CreateTemplatePage",
    middleware: ["auth", "page"],
    mixins: [pageMixin],
    components: {
        FilterDate,
    },
    icons: {
        eye,
    },
    data() {
        return {
            layouts: [
                // Generate 6 layouts items
                ...layouts,
                {
                    name: "Layout 2",
                    description:
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    miniature: "https://via.placeholder.com/150/77179",
                },
                {
                    name: "Layout 3",
                    description:
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    miniature: "https://via.placeholder.com/150/71796",
                },
                {
                    name: "Layout 4",
                    description:
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    miniature: "https://via.placeholder.com/150/77196",
                },
                {
                    name: "Layout 5",
                    description:
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    miniature: "https://via.placeholder.com/150/77196",
                },
                {
                    name: "Layout 6",
                    description:
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    miniature: "https://via.placeholder.com/150/77196",
                },
            ],
        };
    },
    computed: {},
    methods: {
        async updateData() {
            this.updatePageLoading(false);
        },
        async buildPreview(layout, event) {
            console.log(event.target);
            console.log(layout);
            event.stopPropagation();
            alert("Preview not implemente yet");
        },
        async createTemplate() {
            alert("Not implement yet");
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss">
.card-layout {
    border: 1px solid #e5e5e5;
    position: relative;
    & .card-body {
        padding: 0;
    }
    & .card-description {
        padding: 1rem;
    }
    & .btn__build-layout {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        background: #e6e6e6d1;
        border-radius: 40px !important;
        // box-shadow: none !important;
    }
}
</style>
